"use client"

import { CalendarRange } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CalendarRangeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CalendarRangeIcon = component(Icon)({ as: CalendarRange })
